exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".well:nth-of-type(1) ul li{ /* first well;*/\nlist-style-type:none;\n}\n.well:nth-of-type(1) ul li:before{\nfont-family: 'Glyphicons Halflings';\ncontent: \"\\E067\"; \nposition: absolute;\nleft: 25px;\n}\n.well:nth-of-type(2) ul li{ /* second well;*/\nlist-style-type:none;\n}\n.well:nth-of-type(2) ul li:before{ \nfont-family: 'Glyphicons Halflings';\ncontent: \"\\E013\";\nposition: absolute;\nleft: -5px;\n}\n.well:nth-of-type(3) ul li{ /* third well;*/\nlist-style-type:none;\n}\n.well:nth-of-type(3) ul li:before{ \nfont-family: 'Glyphicons Halflings';\ncontent: \"\\E014\";\nposition: absolute;\nleft: -5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/globant/site/src/app/components/services/services.component.css
// module id = ../../../../../src/app/components/services/services.component.css
// module chunks = main